"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _containsInclusive = _interopRequireDefault(require("../../utils/numbers/containsInclusive"));

var _isNumber = _interopRequireDefault(require("../../utils/numbers/isNumber"));

var _isNil = _interopRequireDefault(require("../../utils/object/isNil"));

var _isNotNil = _interopRequireDefault(require("../../utils/object/isNotNil"));

var _isEmpty = _interopRequireDefault(require("../../utils/array/isEmpty"));

var _sortBy = _interopRequireDefault(require("../../utils/array/sortBy"));

var Interval = /*#__PURE__*/function () {
  function Interval(start, end) {
    (0, _classCallCheck2["default"])(this, Interval);
    (0, _defineProperty2["default"])(this, "_start", null);
    (0, _defineProperty2["default"])(this, "_end", null);

    if ((0, _isNotNil["default"])(start) && (0, _isNotNil["default"])(end)) {
      if (!(0, _isNumber["default"])(start) || !(0, _isNumber["default"])(end)) {
        throw new Error("".concat(this.constructor.name, " must be constructed with numbers ").concat(start, ", ").concat(end));
      }

      this._start = start;
      this._end = end;
    }
  }

  (0, _createClass2["default"])(Interval, [{
    key: "copy",
    value: function copy() {
      return new Interval(this.start, this.end);
    }
  }, {
    key: "equals",
    value: function equals(otherInterval) {
      if (!Interval.isInterval(otherInterval)) return false;
      return this.start === otherInterval.start && this.end === otherInterval.end;
    }
  }, {
    key: "containsNumber",
    value: function containsNumber(number) {
      return (0, _containsInclusive["default"])(number, this.start, this.end);
    }
  }, {
    key: "intersects",
    value: function intersects(interval) {
      return Interval.haveIntersection(this, interval);
    }
  }, {
    key: "projectOntoInterval",

    /**
     * @function projectOntoInterval
     * This function takes the interval and "maps" it onto another interval.
     * The original interval is first normalized so that it intersects with the target interval.
     * If the original interval intersects a boundary of the target interval,
     * the overflow wraps around to the head/tail of the target interval.
     *
     * @param {Interval} target interval to map on to
     * @returns {Interval[]} one or two intervals
     *
     * Examples:
     * [8,9].projectOntoInterval([0,10]) returns [[8,9]]
     * [8,12].projectOntoInterval([0,10]) will be [[0,1], [8,10]]
     * [21,24].projectOntoInterval([0,10]) will be [[1,4]]
     */
    value: function projectOntoInterval(targetInterval) {
      if (!Interval.isInterval(targetInterval)) {
        throw new Error('Cannot do project operation on given type');
      } // interval is smaller and inside of target


      if (targetInterval.contains(this)) return [this]; // interval is larger than the target

      if (this.length >= targetInterval.length) return [targetInterval]; // otherwise, shift the interval until it overlaps with the target

      var startInInterval = (this.start - targetInterval.start) % targetInterval.length;

      if (startInInterval < 0) {
        startInInterval = targetInterval.length + startInInterval;
      }

      startInInterval += targetInterval.start;
      var endInInterval = (this.end - targetInterval.start) % targetInterval.length;

      if (endInInterval < 0) {
        endInInterval = targetInterval.length + endInInterval;
      }

      endInInterval += targetInterval.start; // with it shifted, if the start is before end, return the interval

      if (startInInterval < endInInterval) {
        // Shifted interval doesn't wrap, return it.
        return [new Interval(startInInterval, endInInterval)];
      } else {
        // Shifted interval wraps, return head and tail intervals.
        return [new Interval(targetInterval.start, endInInterval), new Interval(startInInterval, targetInterval.end)];
      }
    }
    /**
     * @function relativeComplementIn Find relative complement of current interval in provided interval list
     * @param  {Interval[]} intervalList
     * @return {Interval[]} a.k.a set difference https://en.wikipedia.org/wiki/Complement_(set_theory)
     */

  }, {
    key: "relativeComplementIn",
    value: function relativeComplementIn(intervalList) {
      var _this = this;

      var intersections = [];
      intervalList.forEach(function (interval) {
        if (!Interval.isInterval(interval)) {
          return;
        }

        var intersection = Interval.intersection(_this, interval);

        if ((0, _isNotNil["default"])(intersection)) {
          intersections.push(intersection);
        }
      });
      var relativeComponents = [this];
      intersections.forEach(function (intersectionRange) {
        var newRelativeComponents = [];
        relativeComponents.forEach(function (interval) {
          if (Interval.haveIntersection(interval, intersectionRange)) {
            var disjunctiveUnion = Interval.disjuntiveUnion(interval, intersectionRange);
            newRelativeComponents = newRelativeComponents.concat(disjunctiveUnion);
          } else {
            newRelativeComponents.push(interval);
          }
        });
        relativeComponents = newRelativeComponents;
      });
      return relativeComponents;
    }
    /**
     * @function contains
     * @param  {Interval} interval
     * @return {boolean} returns true if the Interval contains the provided interval
     */

  }, {
    key: "contains",
    value: function contains(interval) {
      if (!Interval.isInterval(interval)) {
        throw new Error('Cannot do contains operation on given type');
      }

      return interval.start >= this.start && interval.end <= this.end;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        start: this.start,
        end: this.end
      };
    }
    /**
     * @function toString
     * @return {string} returns stringified interval in the format `[${start}, ${end}]`
     */

  }, {
    key: "toString",
    value: function toString() {
      return "[".concat(this._start, ", ").concat(this._end, "]");
    }
  }, {
    key: "start",
    get: function get() {
      return this._start;
    },
    set: function set(value) {
      this._start = value;
    }
  }, {
    key: "end",
    get: function get() {
      return this._end;
    },
    set: function set(value) {
      this._end = value;
    }
  }, {
    key: "length",
    get: function get() {
      return Math.abs(this._end - this._start) + 1;
    }
  }], [{
    key: "isInterval",
    value: function isInterval(interval) {
      return interval instanceof Interval;
    }
    /**
     * @function intersection
     * @param  {Interval} interval
     * @return {Interval | null}
     */

  }, {
    key: "intersection",
    value: function intersection(interval1, interval2) {
      if (!Interval.isInterval(interval1) || !Interval.isInterval(interval2)) {
        throw new Error('Cannot do intersection operation on given type');
      }

      if (!Interval.haveIntersection(interval1, interval2)) {
        return null;
      }

      return new Interval(Math.max(interval1.start, interval2.start), Math.min(interval1.end, interval2.end));
    }
    /**
     * @function haveIntersection
     * @param  {Interval} interval1
     * @param  {Interval} interval2
     * @return {boolean} returns true if the intervals intersect
     */

  }, {
    key: "haveIntersection",
    value: function haveIntersection(interval1, interval2) {
      if (!Interval.isInterval(interval1) || !Interval.isInterval(interval2)) {
        throw new Error('Cannot do haveIntersection operation on given type');
      }

      return interval1.start <= interval2.end && interval1.end >= interval2.start;
    }
    /**
     * @function union Given a list of intervals,
     * we sort and return their union i.e. [{10, 20}, {21, 30}, {15, 17}] => [{10,30}]
     * @param  {Interval[]} intervalList
     * @return {Interval[]}
     */

  }, {
    key: "union",
    value: function union(intervalList) {
      if ((0, _isEmpty["default"])(intervalList)) {
        return [];
      }

      var sortedIntervals = (0, _sortBy["default"])(intervalList, 'start');
      return Interval.unsortedUnion(sortedIntervals);
    }
    /**
     * @function unsortedUnion Given a list of unsorted intervals
     * return their union i.e. [{10, 20}, {21, 30}, {15, 17}] => [{10,30}]
     * @param  {Interval[]} intervalList
     * @return {Interval[]}
     */

  }, {
    key: "unsortedUnion",
    value: function unsortedUnion(intervalList) {
      if ((0, _isEmpty["default"])(intervalList)) {
        return [];
      }

      var unionList = [];
      var currentlyProcessingInterval = intervalList[0];

      for (var i = 1; i < intervalList.length; i++) {
        var interval = intervalList[i];

        if (Interval.haveIntersection(currentlyProcessingInterval, interval) || currentlyProcessingInterval.end + 1 === interval.start) {
          currentlyProcessingInterval.end = Math.max(currentlyProcessingInterval.end, interval.end);
        } else {
          unionList.push(currentlyProcessingInterval);
          currentlyProcessingInterval = interval;
        }
      }

      unionList.push(currentlyProcessingInterval);
      return unionList;
    }
    /**
     * @function Interval Calculated disjuntive union between the provided intervals
     * @param  {Interval} interval1
     * @param  {Interval} interval2
     * @return {Interval[]} https://en.wikipedia.org/wiki/Symmetric_difference
     */

  }, {
    key: "disjuntiveUnion",
    value: function disjuntiveUnion(interval1, interval2) {
      if (!Interval.isInterval(interval1) || !Interval.isInterval(interval2)) {
        throw new Error('Cannot do disjuntiveUnion operation on given type');
      }

      var intersection = Interval.intersection(interval1, interval2);

      if ((0, _isNil["default"])(intersection)) {
        return [interval1, intersection];
      }

      var disjuntiveUnion = [];

      if (interval1.start !== interval2.start) {
        disjuntiveUnion.push(new Interval(Math.min(interval1.start, interval2.start), intersection.start - 1));
      }

      if (interval1.end !== interval2.end) {
        disjuntiveUnion.push(new Interval(intersection.end + 1, Math.max(interval1.end, interval2.end)));
      }

      return disjuntiveUnion;
    }
  }]);
  return Interval;
}();

exports["default"] = Interval;
(0, _defineProperty2["default"])(Interval, "fromJSON", function (interval) {
  var start = interval.start,
      end = interval.end;
  return new Interval(start, end);
});